// /src/pages/admin/contratos/Contratos.jsx
import React, { useState } from "react";
import axios from "../../../api/axios";

export default function Contratos() {
  const [file, setFile] = useState(null);
  const [contracts, setContracts] = useState([]);

  // Manejo del archivo seleccionado
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // Subir documento
  const handleUpload = async () => {
    if (!file) {
      alert("Selecciona un archivo antes de subir");
      return;
    }

    const formData = new FormData();
    formData.append("contract", file);

    try {
      // Suponiendo que el endpoint para subir contratos sea /contracts/upload
      await axios.post("/contracts/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("Contrato subido correctamente");
      setFile(null);
      // Aquí podrías recargar la lista de contratos
    } catch (err) {
      console.error(err);
      alert("Error al subir contrato");
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-xl font-bold mb-4">Contratos</h1>

      <div className="mb-4">
        <label className="block mb-2 font-semibold">Subir nuevo contrato:</label>
        <input type="file" onChange={handleFileChange} />
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded ml-2"
          onClick={handleUpload}
        >
          Subir
        </button>
      </div>

      <div>
        <h2 className="text-lg font-bold mb-2">Contratos existentes:</h2>
        {contracts.length === 0 ? (
          <p>No hay contratos subidos</p>
        ) : (
          <ul className="list-disc pl-5">
            {contracts.map((c, idx) => (
              <li key={idx}>{c.name}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
